/* Taken from https://github.com/pburtchaell/redux-promise-middleware/blob/master/src/isPromise.js */
/* Commit 4714443 */

export default function isPromise(value) {
	if (value !== null && typeof value === 'object') {
		return value.promise && typeof value.promise.then === 'function';
	}

	return false;
}



// WEBPACK FOOTER //
// ./src/redux/middleware/isPromise.js